import React from 'react'
import Table from './cards/Table'

const Eeoc: React.FC = () => {
  return (
    <Table />
  )
}

export default Eeoc
